import { handleUserQuantityDefinitionCategoryUpdated } from "../quantityDefinitionCategoryUpdated/user";
import { handleAdminQuantityDefinitionCategoryDeleted } from "./admin";

export function deleteQuantityDefintionCategory(state, patch) {

    // console.log('deleteQuantityDefintionCategory: ', patch)
    const { visibility, payload } = patch;
    if (patch.visibility === "admin") {
        return handleAdminQuantityDefinitionCategoryDeleted(state, payload);
    }

    return handleUserQuantityDefinitionCategoryUpdated(state, payload);
}